module.exports = __webpack_public_path__ + "img/8.c0e0cef4.png";